import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Ruler = createReactComponent("Ruler", ["svg", defaultAttributes, [["path", {
  d: "M16 2l6 6L8 22l-6-6L16 2",
  key: "ltwcqc"
}], ["path", {
  d: "M7.5 10.5l2 2",
  key: "1na9wt"
}], ["path", {
  d: "M10.5 7.5l2 2",
  key: "34qx5i"
}], ["path", {
  d: "M13.5 4.5l2 2",
  key: "1bhj2u"
}], ["path", {
  d: "M4.5 13.5l2 2",
  key: "1ayu9b"
}]]]);
export default Ruler;